import { max } from "lodash";
import { AccessParentWithChildren } from "server/coreApi/accessParents/types.js";

export const accessParentsWithFillLevel = (
  accessParents: AccessParentWithChildren[],
) =>
  accessParents.map((ap) => {
    const fillLevels = ap.containers.map((el) => el.fillLevel);
    const maxLevel = max(fillLevels);

    return {
      ...ap,
      fillLevel: maxLevel,
    };
  });
